import settings from './settings';
import axios from 'axios';

export async function getUser(accessToken) {
  return axios.get(settings.endpoints.getUser, {
    headers: {
      Authorization: accessToken
    }
  })
}

export async function getUserInvitation(token){
  return axios.get(settings.endpoints.userGetInvitation(token), {

  });
}

export async function acceptUserInvitation(token, data){
  return axios.post(settings.endpoints.userAcceptInvitation(token),data,{
  })
}

export async function requestResetPassword(data){
  return axios.post(settings.endpoints.requestResetPassword(), data);
}

export async function resetPassword(data){
  return axios.post(settings.endpoints.resetPassword(), data);
}
